
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/covid-ready-for-orgs",
      function () {
        return require("private-next-pages/covid-ready-for-orgs.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/covid-ready-for-orgs"])
      });
    }
  